import { ChangePasswordInfos } from "@/src/types";
import api from "../api";

export async function changePassword(
    changePasswordInfos: ChangePasswordInfos
): Promise<any | null> {
    // force email to lowercase
    changePasswordInfos.email = changePasswordInfos.email.toLowerCase();

    return await api
        .post("/api/change-password/", changePasswordInfos)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function resetPasswordRequest(
    email: string
): Promise<any | null>{
    const url = `/auth/request-password-reset/`;
    // force email to lowercase
    email = email.toLowerCase();

    return await api
        .post(url, {email: email, url_front: encodeURIComponent(window.location.origin + "/resetpassword")}).then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function resetPassword(
    password: string,
    confirmNewPassWord: string,
    token: string | null
): Promise<any | null>{
    const url = `/auth/reset-password/`;
    return await api
        .post(url, {token: token, new_password: password, confirm_new_password: confirmNewPassWord}).then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}
